import type { WalkthroughEvent } from '@shared-types/frontend-scenario-definition';

export const participantReportWalkthrough: WalkthroughEvent = {
    key: 'participant-report-walkthrough',
    showAt: 'start',
    steps: [
        {
            id: '0',
            element: { selector: '[data-tour=recommended-tasks]' },
            position: 'right',
            text: 'app.dashboard.dashboardTour.recommendedTasks',
        },
        {
            id: '1',
            element: { selector: '[data-tour=retake-tasks]' },
            text: 'app.dashboard.dashboardTour.retakeTasks',
        },
        {
            id: '2',
            element: { selector: '[data-tour=recent-tasks]' },
            text: 'app.dashboard.dashboardTour.recentTasks',
        },
    ],
};

export default participantReportWalkthrough;
